import styled from 'styled-components';

export const FormSeparator = styled.hr`
    width: 100%;
    border-top: 1px solid #eeeef2;
    max-width: 100vw !important;
`;
